import { PosixDateTransformer } from "../time/posix-date.js";
export const BaseColumnSchemaPart = {
    id: {
        type: "uuid",
        primary: true,
    },
    createdAt: {
        type: "date",
        createDate: true,
        transformer: PosixDateTransformer,
    },
    updatedAt: {
        type: "date",
        updateDate: true,
        transformer: PosixDateTransformer,
    },
    deletedAt: {
        type: "date",
        updateDate: true,
        nullable: true,
        transformer: PosixDateTransformer,
    },
};
